import logo from 'assets/images/logo/jseyoung_lion_shield_green.png';

// ==============================|| JEISEYOUNG LOGO ICON IMAGE ||============================== //

export default function LogoIcon() {
  return <img src={logo} alt="Jeiseyoung" width="36" height="36" style={{ display: 'block', objectFit: 'contain' }} />;
}
